var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Attachment',{attrs:{"name":_vm.name,"readonly":_vm.readonly,"view":_vm.view,"value":_vm.fileInfo,"disabled":_vm.disabled,"errorMessage":_vm.errorMessage},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }